// MiniERPPriceFlowAPI.js
// If your existing `useFetch` hook already handles auth headers + JSON parsing,
// swap the body of `request()` below to call it instead — every exported
// function here stays the same, so nothing else in this module changes.
// Public endpoints (customer-facing) intentionally send NO auth header.

const BASE_URL = '/minierp/priceflow';

function getToken() {
  return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken') || '';
}

async function request(path, { method = 'GET', body, params, auth = true } = {}) {
  let url = `${BASE_URL}${path}`;
  if (params) {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null)
    ).toString();
    if (qs) url += `?${qs}`;
  }

  const headers = { 'Content-Type': 'application/json' };
  if (auth) headers.Authorization = `Bearer ${getToken()}`;

  const res = await fetch(url, { method, headers, body: body ? JSON.stringify(body) : undefined });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    throw new Error(json.message || `Request failed (${res.status})`);
  }
  return json.data;
}

// ---------- Merchant: Business ----------
export const createBusiness = (body) => request('/business', { method: 'POST', body });
export const getMyBusinesses = () => request('/business');
export const getBusiness = (id) => request(`/business/${id}`);
export const updateBusiness = (id, body) => request(`/business/${id}`, { method: 'PUT', body });
export const publishBusiness = (id) => request(`/business/${id}/publish`, { method: 'POST' });
export const shareBusiness = (id) => request(`/business/${id}/share`, { method: 'POST' });
export const getBusinessAnalytics = (id) => request(`/business/${id}/analytics`);

// ---------- Merchant: Products ----------
export const createProduct = (body) => request('/products', { method: 'POST', body });
export const listProducts = (params) => request('/products', { params });
export const updateProduct = (id, body) => request(`/products/${id}`, { method: 'PUT', body });
export const deleteProduct = (id) => request(`/products/${id}`, { method: 'DELETE' });
export const duplicateProduct = (id) => request(`/products/${id}/duplicate`, { method: 'POST' });
export const reorderProducts = (businessId, order) => request('/products/reorder', { method: 'POST', body: { businessId, order } });

// ---------- Public: live price page (no auth) ----------
export const getPublicBusiness = (slug) => request(`/public/${slug}`, { auth: false });
export const getPublicProducts = (slug, params) => request(`/public/${slug}/products`, { params, auth: false });
